import React from "react";
import { motion } from "framer-motion";
import { SectionHeader } from "./Services";

export default function Process({ content }) {
  const steps = content?.process || [];
  return (
    <section id="proceso" className="relative py-24 sm:py-28 px-5 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <SectionHeader eyebrow="Cómo trabajamos" title="Sabés qué vamos a hacer y por qué, en cada etapa" sub="Método claro, comunicación directa y entregables concretos. Sin sorpresas." />
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-line-2 border border-line-2">
          {steps.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-50px" }} transition={{ duration: 0.5, delay: i*0.08 }}
              className="bg-base p-7 relative">
              <div className="flex items-center justify-between">
                <div className="text-fg text-[44px] font-semibold leading-none tracking-tight">{s.step}</div>
                <div className="w-8 h-px bg-brand" />
              </div>
              <h4 className="mt-6 text-fg text-[17px] font-semibold leading-tight">{s.title}</h4>
              <p className="mt-2.5 text-mute text-[14px] leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
